module.exports = __webpack_public_path__ + "img/img3.d464b27d.jpg";